export const info = {
  usage: {
    noRecords: 'There are no available resources',
    deleteMsg: 'Are you sure you want to remove this usage from the transaction inventory?',
  },
};
